
import { useState, useContext } from "react";
import { UserContext } from "../UserContext";
import { Link} from 'react-router-dom';
import { Button, Card , Form , Row , Col} from 'react-bootstrap';
import logo from '../assets/logo_rushters_negro.png';
import Image from 'react-bootstrap/Image';
const  ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [emailMessage, setEmailMessage] = useState(false)
  const {sendPasswordReset} =  useContext(UserContext);
   const [validated, setValidated] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await sendPasswordReset(email);
      setEmailMessage(true);
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        alert('User not found, try again!')
        setEmail('')
      }
    }
  };

  return (
    <div>
        <div className='pt-5'>
        <Card className="text-center " >
            <Card.Header className='titleDefault' >
                <Image fluid src={logo} width={200} height={40}/>
            </Card.Header>
            <Card.Body>
                <Card.Title className='titleDefault pb-2'></Card.Title>
                {
                    emailMessage ?
                    <h4>Link de recuperación enviado; revisa tu email: {email} </h4> :
                    <Form  validated={validated} onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                        <Form.Label column sm="3">
                        </Form.Label>
                        <Col sm="6">
                        <Form.Control
                        type="email"
                        placeholder="Email"
                        onChange={(event) => setEmail(event.currentTarget.value)}
                        value={email}
                        required
                        />
                        <Form.Control.Feedback type="invalid">
                            Ingresa un email
                        </Form.Control.Feedback>
                        </Col>
                    </Form.Group>
                    <Button  className='mt-3 mb-3 btn btn-sm btn-block btn-primary' type='submit' >
                        Recuperar contraseña
                    </Button>
                    <p>~ o ~</p>

                    <Link to={'/'} className='mt-3 mb-3  btn-block btn-primary' type="link" >
                        Iniciar sesión
                    </Link>
                    </Form>
                }

            </Card.Body>
        </Card>
        </div>


    </div>
  )
}

export default ForgotPassword
